export const LOGIN_WAIVER_ERROR_MESSAGE = 'Must sign the waiver before logging in.'

export const BIRTHPLACE_CANADA_NO_OPTION = 'No'
export const BIRTHPLACE_CANADA_YES_AT_LEAST_ONE_PARENT_GUARDIAN_OPTION =
  'Yes, I was born in Canada, but at least one parent/guardian was born outside of Canada'
export const BIRTHPLACE_CANADA_YES_PARENTS_GUARDIANS_OPTION =
  'Yes, I was born in Canada and my parent(s)/guardian(s) were also born in Canada'
export const BIRTHPLACE_CANADA_YES_INDIGENOUS_OPTION = 'Yes, I am Indigenous to Canada'
export const BIRTHPLACE_CANADA_DONT_KNOW_OPTION = "Don't know"
export const BIRTHPLACE_CANADA_PREFER_NOT_TO_ANSWER_OPTION = 'Prefer not to answer'
export const BIRTHPLACE_CANADA_DROPDOWN = [
  {
    label: BIRTHPLACE_CANADA_NO_OPTION,
    value: BIRTHPLACE_CANADA_NO_OPTION,
  },
  {
    label: BIRTHPLACE_CANADA_YES_AT_LEAST_ONE_PARENT_GUARDIAN_OPTION,
    value: BIRTHPLACE_CANADA_YES_AT_LEAST_ONE_PARENT_GUARDIAN_OPTION,
  },
  {
    label: BIRTHPLACE_CANADA_YES_PARENTS_GUARDIANS_OPTION,
    value: BIRTHPLACE_CANADA_YES_PARENTS_GUARDIANS_OPTION,
  },
  {
    label: BIRTHPLACE_CANADA_YES_INDIGENOUS_OPTION,
    value: BIRTHPLACE_CANADA_YES_INDIGENOUS_OPTION,
  },
  {
    label: BIRTHPLACE_CANADA_DONT_KNOW_OPTION,
    value: BIRTHPLACE_CANADA_DONT_KNOW_OPTION,
  },
  {
    label: BIRTHPLACE_CANADA_PREFER_NOT_TO_ANSWER_OPTION,
    value: BIRTHPLACE_CANADA_PREFER_NOT_TO_ANSWER_OPTION,
  },
]
export const PRONOUN_OPTION_HE_HIM = 'He/Him'
export const PRONOUN_OPTION_SHE_HER = 'She/Her'
export const PRONOUN_OPTION_THEY_THEM = 'They/Them'
export const PRONOUN_OPTION_SELF_DESCRIBE = 'Prefer to self-describe'
export const PRONOUN_OPTIONS = [
  PRONOUN_OPTION_HE_HIM,
  PRONOUN_OPTION_SHE_HER,
  PRONOUN_OPTION_THEY_THEM,
  PRONOUN_OPTION_SELF_DESCRIBE,
].map(e => ({
  value: e,
  label: e,
}))

export const MALE_GENDER_TEXT_OPTION = 'Boy/Man'
export const MALE_GENDER_OPTION = 'Male'
export const FEMALE_GENDER_TEXT_OPTION = 'Girl/Woman'
export const FEMALE_GENDER_OPTION = 'Female'
export const TRANSGENDER_GENDER_OPTION = 'Transgender'
export const OTHER_GENDER_OPTION = 'Other'
export const UNSPECIFIED_GENDER_OPTION = 'Unspecified'
export const NON_BINARY_GENDER_OPTION = 'Non-binary'
export const TWO_SPIRIT_GENDER_OPTION = 'Two Spirit'
export const NON_BINARY_GENDER_OPTIONS = [
  TRANSGENDER_GENDER_OPTION,
  OTHER_GENDER_OPTION,
  UNSPECIFIED_GENDER_OPTION,
  TWO_SPIRIT_GENDER_OPTION,
]
export const GENDER_OPTIONS = [
  MALE_GENDER_OPTION,
  FEMALE_GENDER_OPTION,
  TRANSGENDER_GENDER_OPTION,
  OTHER_GENDER_OPTION,
  UNSPECIFIED_GENDER_OPTION,
  NON_BINARY_GENDER_OPTION,
  TWO_SPIRIT_GENDER_OPTION,
]

export const EVENT_GENDER_OPTIONS = [
  {
    label: 'Boy/Man',
    value: MALE_GENDER_OPTION,
  },
  {
    label: 'Girl/Woman',
    value: FEMALE_GENDER_OPTION,
  },
  {
    label: NON_BINARY_GENDER_OPTION,
    value: NON_BINARY_GENDER_OPTION,
  },
  {
    label: TWO_SPIRIT_GENDER_OPTION,
    value: TWO_SPIRIT_GENDER_OPTION,
  },
  {
    label: OTHER_GENDER_OPTION,
    value: OTHER_GENDER_OPTION,
  },
  {
    label: UNSPECIFIED_GENDER_OPTION,
    value: UNSPECIFIED_GENDER_OPTION,
  },
  {
    label: 'All Genders',
    value: 'All Genders',
  },
]

export const EVENT_ALL_GENDER_OPTIONS = [
  MALE_GENDER_OPTION,
  FEMALE_GENDER_OPTION,
  NON_BINARY_GENDER_OPTION,
  TWO_SPIRIT_GENDER_OPTION,
  OTHER_GENDER_OPTION,
  UNSPECIFIED_GENDER_OPTION,
]
export const GENDER_OPTIONS_DROPDOWN = [
  {
    label: 'Boy/Man',
    value: MALE_GENDER_OPTION,
  },
  {
    label: 'Girl/Woman',
    value: FEMALE_GENDER_OPTION,
  },
  {
    label: NON_BINARY_GENDER_OPTION,
    value: NON_BINARY_GENDER_OPTION,
  },
  {
    label: TWO_SPIRIT_GENDER_OPTION,
    value: TWO_SPIRIT_GENDER_OPTION,
  },
  {
    label: 'Prefer not to answer',
    value: UNSPECIFIED_GENDER_OPTION,
  },
  {
    label: 'Prefer to self-describe',
    value: OTHER_GENDER_OPTION,
  },
]
export const USER_STATUS_ACTIVE = 'Active'
export const USER_STATUS_INACTIVE = 'Inactive'
export const USER_STATUS_ALUMNI = 'Alumni'
export const USER_STATUS_PENDING = 'Pending'
export const USER_STATUS_INVITED = 'Invited'
export const USER_STATUS_EXPIRED = 'Expired'
export const USER_STATUSES = [USER_STATUS_ACTIVE, USER_STATUS_INACTIVE, USER_STATUS_ALUMNI]
export const DEFAULT_RACE_OPTION_TEXT = 'Prefer not to answer'
export const DEFAULT_RACE_OPTION = ['Prefer not to answer'].map(e => ({ value: e, label: e }))
export const RACE_SELF_DESCRIBE_OPTION = 'Prefer to self-describe:'
export const RACE_OPTIONS_CHECKLIST = [
  'Black (African, Afro-Caribbean, or African-Canadian descent)',
  'East Asian (Chinese, Korean, Japanese, etc.)',
  'Indigenous (First Nations, Inuit, or Metis)',
  'Latinx (Latin American or Hispanic descent)',
  'Middle Eastern (Arab, Persian, or West Asian descent e.g. Afghan, Egyptian, Iranian, Lebanese, Turkish, Kurdish, etc.)',
  'South Asian (East Indian, Pakistani, Bangladeshi, Sri Lankan, Indo-Caribbean, etc.)',
  'Southeast Asian (Filipino, Vietnamese, Cambodian, Thai, Indonesian, etc.)',
  'White (European descent)',
  DEFAULT_RACE_OPTION_TEXT,
  RACE_SELF_DESCRIBE_OPTION,
]
